<template>
  <el-dialog :append-to-body="true" :visible.sync="dialogVisible" title="询单操作日志" width="30%" :close-on-click-modal="false">
    <div class="inquiry-operation-log">
      <div class="log-content" v-loading="loading">
        <el-timeline v-if="logList.length > 0">
          <el-timeline-item v-for="(item, index) in logList" :key="index" placement="top">
            <div class="timeline-item-content">
              <div class="item-row">
                <span class="time-text">{{ dateFormatYMDHMS(item.createTime,'-') }}</span>
                <span class="content-text">{{ item.oprationContent}}</span>
              </div>
            </div>
          </el-timeline-item>
        </el-timeline>
        <el-empty v-else description="暂无操作日志" :image-size="100"></el-empty>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import Api from '@/components/Api/index.js'
import { dateUtil } from '@/mixins/dateUtil.js'

export default {
  name: 'InquiryOperation',
  mixins: [dateUtil],
  data() {
    return {
      dialogVisible: false,
      inquiryId: '',
      loading: false,
      logList: [],
    }
  },
  methods: {
    // 打开弹框
    openDialog(inquiryId) {
      this.inquiryId = inquiryId
      this.dialogVisible = true
      this.loadLogList()  
    },
    
    // 加载日志列表（一次性加载所有数据）
    loadLogList() {
      this.loading = true 
      const params = {
        inquiryId: this.inquiryId,
      }
      // 调用API获取日志列表
      new Api('inquiry').getInquiryOperationLog(params).then(res => {
        if (res.status === 200) {
          let list = res.data
          this.logList = list
        } else {
          this.$message.error(res.statusText || '获取日志列表失败')
          this.logList = []
        }
      }).catch(err => {
        this.$message.error('获取日志列表失败')
        this.logList = []
      }).finally(() => {
        this.loading = false
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.inquiry-operation-log {
  display: flex;
  flex-direction: column;
  min-height: 500px;
  
  .filter-section {
    background: #f5f7fa;
    padding: 15px;
    border-radius: 4px;
    margin-bottom: 20px;
    
    .filter-form {
      margin: 0;
    }
  }
  
  .log-content {
    flex: 1;
    overflow-y: auto;
    max-height: 600px;
    padding: 10px 0;
    
    .timeline-item-content {
      background: #fff;
      border-radius: 4px;
      transition: all 0.3s;
      
      &:hover {
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border-color: #409eff;
      }
      
      .item-row {
        display: flex;
        align-items: center;
        gap: 15px;
        
        .time-text {
          color: #909399;
          font-size: 13px;
          white-space: nowrap;
          flex-shrink: 0;
          min-width: 120px;
        }
        
        .content-text {
          color: #303133;
          font-size: 14px;
          line-height: 1.6;
          flex: 1;
          word-break: break-all;
        }
      }
    }
  }
}

::v-deep .el-dialog__body {
  padding: 20px;
}

::v-deep .el-timeline {
  padding-left: 0;
  
  .el-timeline-item {
    padding-bottom: 10px;
    
    .el-timeline-item__timestamp {
      display: none;
    }
  }
}

::v-deep .el-empty {
  padding: 40px 0;
}
</style>

